



























































































import { MessageService } from '@/services/messageService';
import { Vue, Component, Ref, Prop, Watch } from 'vue-property-decorator';
import { ComponentItem } from '@/modules/neovehicle/models';
import { IMarket } from '@/modules/neovehicle/models';
import MarketControl from '@/modules/neovehicle/components/market-controls.component.vue';
import { Market } from '@/modules/neovehicle/models/market';

@Component({
  components: {MarketControl},
})
export default class extends Vue {
  @Prop() public data: ComponentItem[];
  @Prop(String) public newTextLabel: string;
  @Prop(String) public btnAddLabel: string;
  @Prop(String) public btnDeleteLabel: string;
  @Prop(String) public name: string;
  @Prop() public rules: any[];
  @Prop() public value: number;
  @Prop(Boolean) public isHideAddItem: boolean;
  @Prop({ default: false, required: false, type: Boolean })
  public isReadonly: boolean;
  @Prop()
  public isFamilyVersion: boolean;

  @Ref('form')
  public form: HTMLFormElement;

  @Ref('formAdd')
  public formAdd: HTMLFormElement;

  @Ref('radioList')
  public radioList: Vue;

  public Market = Market;
  public defaultRules: any[] = [(v: any) => !!v || 'Campo obrigatório.'];
  public market: IMarket = new Market('0', '');

  public newItemName: string | null = null;
  public newItem: ComponentItem | null = null;
  public selected: number | null = null;

  public get btnDisabled(): boolean {
    let disabled = !this.newItemName && !!this.selected;

    if (this.isFamilyVersion) {
      const [ok, _] = this.market.validate();

      disabled = disabled || !ok;
    }

    return disabled;
  }

  public created() {
    this.selected = this.value;
  }

  @Watch('value')
  public onChangeValue(value: number, old: number) {
    this.handleChange(value);
  }

  @Watch('newItemName')
  public onChangeNewItem(value: string ) {
    this.newItemName = value.toPascalCase();
  }

  public handleChange(value: number) {
    this.selected = value;
    const dataItem = this.data.filter((x) => x.id === value);

    this.$emit('valid', value != null);

    dataItem.length
      ? (this.$emit('change', value, dataItem[0].name))
      : (this.$emit('change', value));

    if (this.form) {
      this.form.resetValidation();
    }

    if (this.formAdd) {
      this.formAdd.resetValidation();
    }

    this.changeColorSelected();
  }

  public handleAddNewItem() {
    if (this.formAdd.validate()) {
      if (
        this.data.filter(
          (x: ComponentItem) =>
            x.name &&
            x.name.trim().toPascalCase() ===
            this.newItemName!.trim().toPascalCase(),
        ).length
      ) {
        MessageService.Warning(
          'Atenção',
          'Já existe esse nome na lista.',
          'center',
        );
        this.newItemName = '';
        return;
      }

      this.newItem = {
        id: 0,
        name: this.newItemName!.toPascalCase(),
        market: this.market,
      };

      this.setScrollToEndPosition();

      this.$emit('addNewItem', this.newItem);
      this.handleChange(0);
    }
  }

  public handleDeleteNewItem() {
    this.newItem = null;
    this.newItemName = null;
    if (this.formAdd) {
      this.formAdd.resetValidation();
    }
    this.$emit('deleteNewItem');
    this.$emit('valid', false);
  }

  public changeColorSelected() {
    this.$nextTick(() => {
      const marked = document.querySelector(
        `.${this.name}.form-radio-group-list .mdi-radiobox-marked`,
      );
      document.querySelectorAll(`.${this.name}.v-radio`).forEach((x) => {
        (x as HTMLElement).style.backgroundColor = '#fff';
        (x as HTMLElement).querySelector('label')!.style.color =
          'rgb(0,0,0, 0.54)';
      });

      if (marked) {
        const div = marked.parentElement!.parentElement!;

        div.style.backgroundColor = '#5cbbf6';

        div.querySelector('label')!.style.color = '#fff';
      }
    });
  }

  public mounted() {
    this.changeColorSelected();
    if (this.formAdd) {
      this.formAdd.resetValidation();
    }
    this.$emit('valid', false);
    this.newItemName = null;
    this.newItem = null;
  }

  private setScrollToEndPosition() {
    (this.radioList as Vue & { $el: () => any })!.$el!.querySelector('.v-input--radio-group__input')!.scrollLeft = (this.radioList as Vue & { $el: () => any })!.$el!.querySelector('.v-input--radio-group__input')!.scrollWidth;
  }
}
